import styled, { keyframes } from "styled-components";

const dotTyping = keyframes`
    0% {
        box-shadow: 9991px 0 0 0 #13141b, 9999px 0 0 0 #13141b, 10007px 0 0 0 #13141b;
    }
    20% {
        box-shadow: 9991px -5px 0 0 #13141b, 9999px 0 0 0 #13141b, 10007px 0 0 0 #13141b;
    }
    50% {
        box-shadow: 9991px 0 0 0 #13141b, 9999px -8px 0 0 #13141b, 10007px 0 0 0 #13141b;
    }
    83.333% {
        box-shadow: 9991px 0 0 0 #13141b, 9999px 0 0 0 #13141b, 10007px -10px 0 0 #13141b;
    }
    95% {
        box-shadow: 9991px 0 0 0 #13141b, 9999px 0 0 0 #13141b, 10007px 0 0 0 #13141b;
    }
    100% {
        box-shadow: 9991px 0 0 0 #13141b, 9999px 0 0 0 #13141b, 10007px 0 0 0 #13141b;
    }
`;

export const ButtonDS = styled.button`
	&.btn {
		--vm-btn-padding-y: 0.5rem;
		--vm-btn-padding-x: 1rem;

		--vm-btn-white-space: ;
		--vm-btn-color: #13141b;
		--vm-btn-bg: #01e59b;
		--vm-btn-hover-primary-color: #15e7a3;
		--vm-btn-hover-color: rgba(255, 255, 255, 0.08);
		--vm-btn-icon-contrast: rgba(35, 36, 47, 0.24);
		--vm-btn-min-width: 0.75rem;
		--vm-btn-border-width: 0;
		--vm-btn-box-shadow: none;
		--vm-btn-focus-width: 4px;
		--vm-btn-focus-box-shadow: ;
		--vm-btn-disabled-opacity: 0.24;
		--vm-btn-active-box-shadow: inset 0 3px 5px rgba(19, 20, 27, 0.125);
		--vm-btn-border-radius: 8px;
		--vm-btn-border-radius-sm: 8px;
		--vm-btn-border-radius-lg: 16px;
		--vm-btn-transition:
			color 0.15s ease-in-out, background-color 0.15s ease-in-out,
			border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
		--vm-btn-icon-margin: 4px;
		--vm-btn-min-width: 0.75rem;
		--vm-btn-width: 100%;
		--vm-btn-min-height: 0.25rem;

		display: flex;
		align-items: center;
		justify-content: center;

		padding: var(--vm-btn-padding-y) var(--vm-btn-padding-x);

		width: var(--vm-btn-width);
		min-width: var(--vm-btn-min-width);
		color: var(--vm-btn-color);
		background-color: var(--vm-btn-bg);
		text-align: center;
		white-space: var(--vm-btn-white-space);
		vertical-align: middle;
		cursor: pointer;
		user-select: none;
		box-shadow: inset 0 0 0 var(--vm-btn-border-width) var(--vm-btn-border-color) !important;
		border: none;
		border-radius: var(--vm-btn-border-radius);
		transition:
			color 0.15s ease-in-out,
			background-color 0.15s ease-in-out,
			border-color 0.15s ease-in-out,
			box-shadow 0.15s ease-in-out;
		min-height: var(--vm-btn-min-height);

		&:hover,
		&:active {
			color: var(--vm-btn-color) !important;
			background-color: var(--vm-btn-hover-bg) !important;
			border: none !important;
		}
	}

	&.btn-primary {
		--vm-btn-color: #13141b;
		--vm-icon-color: #13141b;
		--vm-btn-bg: #01e59b;
		--vm-btn-border-color: #15e7a3;
		--vm-btn-hover-color: #13141b;
		--vm-btn-hover-bg: #27e9aa;
		--vm-btn-hover-border-color: #2ce9ac;
		--vm-btn-focus-shadow-rgb: 21, 199, 143;
		--vm-btn-disabled-color: #13141b;
		--vm-btn-disabled-bg: #01e59b;
		--vm-btn-disabled-border-color: #15e7a3;
	}

	&.btn-outline-primary {
		--vm-btn-color: #01e59b;
		--vm-icon-color: #01e59b;
		--vm-btn-border-color: #01e59b;
		--vm-btn-hover-color: rgba(255, 255, 255, 0.08);
		--vm-btn-hover-bg: rgba(255, 255, 255, 0.08);
		--vm-btn-hover-border-color: #01e59b;
		--vm-btn-focus-shadow-rgb: 1, 229, 155;
		--vm-btn-active-color: #13141b;
		--vm-btn-active-bg: #01e59b;
		--vm-btn-active-border-color: #01e59b;
		--vm-btn-disabled-color: #01e59b;
		--vm-btn-disabled-bg: transparent;
		--vm-btn-bg: transparent;
		--vm-gradient: none;
		--vm-btn-border-width: 2px;
	}

	&.btn-fill-primary {
		--vm-btn-color: #01e59b;
		--vm-icon-color: #01e59b;
		--vm-btn-border-color: #01e59b;
		--vm-btn-hover-color: rgba(255, 255, 255, 0.08);
		--vm-btn-hover-bg: rgba(255, 255, 255, 0.08);
		--vm-btn-hover-border-color: #01e59b;
		--vm-btn-focus-shadow-rgb: 1, 229, 155;
		--vm-btn-active-color: #13141b;
		--vm-btn-active-bg: #01e59b;
		--vm-btn-active-border-color: #01e59b;
		--vm-btn-disabled-color: #01e59b;
		--vm-btn-disabled-bg: transparent;
		--vm-btn-bg: transparent;
		--vm-gradient: none;
	}

	&.btn-icon {
		--vm-btn-bg: transparent;
		--vm-btn-color: #ffffff;
		min-width: 32px !important;
		border-radius: 100%;
		padding: 4px;
		line-height: 0;
	}

	&.disabled {
		opacity: 0.24;
	}

	&.dot {
		width: 100%;
		min-height: 2.5rem;
		display: inline-flex !important;
		justify-content: center;
		align-items: center;

		&::after {
			content: "";
			width: 4px;
			height: 4px;
			border-radius: 2px;
			background-color: #13141b;
			color: #13141b;
			position: relative;
			left: -10000px;
			box-shadow:
				9985px 0 0 0 #13141b,
				9991px 0 0 0 #13141b,
				9997px 0 0 0 #13141b;
			animation: ${dotTyping} 1s infinite cubic-bezier(0.81, -0.21, 0.33, 0.1);
		}
	}
`;

export const Label = styled.label`
	--btn-font-size: var(--font-size-huge);
	--btn-font-weight: 600;
	--btn-line-height: 1.5;

	cursor: pointer;
	font-family: var(--font-family-metropolis-semi-bold);
	font-size: var(--btn-font-size);
	font-weight: var(--btn-font-weight);
	line-height: var(--btn-line-height);
	margin: 0;
`;
